export class CreatePrintCredential {

  constructor(
    
    public customerId?: string,
  ) {
  }
}
